function isStandalonePWA(): boolean {
	// Installed PWAs
	return window.matchMedia('(display-mode: standalone)').matches
		|| (window.navigator as any).standalone === true; // iOS Safari
}

function isMobileLike(): boolean {
	// Signals emulated by DevTools device mode (so we’ll treat as mobile there)
	const coarsePointer = window.matchMedia('(pointer:coarse)').matches;
	const narrowViewport = Math.min(window.innerWidth, window.innerHeight) <= 900;
	const touchPoints = navigator.maxTouchPoints || 0;
	const ua = navigator.userAgent || '';
	const uaIsMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
	const uaDataMobile = (navigator as any).userAgentData?.mobile === true;

	return coarsePointer || narrowViewport || touchPoints > 0 || uaIsMobile || uaDataMobile;
}

export function isProbablyDesktop(): boolean {
	// Don’t nag if installed or mobile-like
	if (isStandalonePWA()) return false;
	return !isMobileLike();
}
